/**
 * Non-color design tokens — radii, elevation, and the 4px spacing scale.
 * Colors live in `colors.ts`.
 */

// Warm-tinted elevation — never neutral black.
export const shadows = {
	// Small inner cards (event cards inside the itinerary preview).
	inner: '0 1px 2px rgba(38,18,2,0.06), 0 0 0 1px rgba(38,18,2,0.04)',
	// Resting bento tile / card surface.
	card: '0 4px 12px rgba(84,18,2,0.08), 0 1px 2px rgba(38,18,2,0.04)',
	// Hover / lifted tier.
	cardHover: '0 12px 32px rgba(57,64,128,0.18), 0 2px 6px rgba(38,18,2,0.06)',
} as const

// Corner radii scale (the handoff's spec'd steps only).
export const radii = {
	inner: '12px', // inner media / inputs
	card: '16px', // bento tiles / large cards
	band: '24px', // CTA band / sheet headers
	pill: '999px', // chips / pills
} as const

/**
 * Responsive breakpoints (px). `bentoCollapse` is shared between the CSS media
 * queries and the JS section reorder, so always interpolate the token rather
 * than writing the number.
 */
export const breakpoints = {
	/** At/below this, the 12-col bento collapses to the single-column stack. */
	bentoCollapse: 980,
	/** At/below this, phone-density tuning applies (type ramp, rails, compact chrome). */
	phone: 600,
} as const

/**
 * The centered content column width shared by the navbar, breadcrumbs, and page
 * containers so their edges align. Consume via the `contentShell` mixin or
 * `max-width: ${contentWidth}` — never re-type the literal.
 */
export const contentWidth = '1400px'

// 4px base spacing scale.
export const space = {
	1: '4px',
	2: '8px',
	3: '12px',
	4: '16px',
	5: '20px',
	6: '24px',
	7: '28px',
	8: '32px',
	10: '40px',
	12: '48px',
	16: '64px',
} as const

export type ShadowKey = keyof typeof shadows
export type RadiusKey = keyof typeof radii
export type SpaceKey = keyof typeof space
export type BreakpointKey = keyof typeof breakpoints
